import React from "react";
import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.watermark}>
          <p>2021 Copyright Ateneo Comission on Election.</p>
          <a href="https://dscadmu.org">
            Developed by Developer Student Clubs - Loyola
          </a>
        </div>

        <div className={styles.icons}>
          <a href="https://www.facebook.com/ateneocomelec">
            <div className={styles.icon1} />
          </a>

          <a href="https://twitter.com/AteneoCOMELEC">
            <div className={styles.icon2} />
          </a>

          <a href="mailto:comelec.ls@obf.ateneo.edu">
            <div className={styles.icon3} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
